<template>
<div class="centered" id="live_shows">
    <h1>הופעות קרובות שלי</h1>
    <h3>ליצירת הופעה חדשה שתופיע בלינקיפדיה שלך ותישלח לאתר לינקטון- יש ללחוץ על הוספת הופעה.</h3>

    <div style="text-align: center; padding: 25px 0;">
        <router-link to="/edit_shows/add" class="btn">+ הוספת הופעה</router-link>
    </div>

    <div class="tickets">
        <div class="ticket" v-for="item in items" :key="item.id">
            <div class="pic" :style="bg(item.pic_parsed)">
                <div class="circles"></div>
            </div>

            <div class="details">
                <div class="date">

                <span class="day">11</span>
                <div style="line-height: 15px; text-align: right;">
                    <span v-text="item.date_month_heb"></span>
                    <div class="name" v-text="item.date_days_name"></div>
                </div>
                </div>
                <div class="wrapper_mob">
                    <div class="title" v-text="item.artist_name"></div>
                    <div class="location">
                        <p><i class="far fa-clock" aria-hidden="true"></i>{{ item.time }}</p>
                        <p><i class="fas fa-map-marker-alt" aria-hidden="true"></i>{{ item.location }}</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
export default {
  data(){
    return {
        items: [],
        loaded: false
    }
  },
  mounted(){
       this.api({ action: 'user_shows' }, (data) => { 
        this.items = data.data.items;
      
        this.loaded = true;
      
      } );
  },
  methods:{

  }
  
  
}
</script>
<style  lang="scss" scooped>

#live_shows{
	.title{text-align: center}
	.title.colord{text-align: center;margin-bottom: 20px; background-image: linear-gradient(100deg, #ff1661 40%, #00b7ff 70%); line-height: 30px;}
	.tickets{display: grid; 
        @media (min-width: 600px) { grid-template-columns: repeat(3, 1fr); gap:40px;  }
        @media (max-width: 600px) { grid-template-columns: repeat(2, 1fr); gap:20px; padding: 0 15px; }
    }

    .ticket{ position: relative; box-shadow:0 2px 4px 0 rgba(0, 0, 0, 0.19);  border-radius: 15px;width: 100%; display: flex;
        @media (min-width: 600px) {   }
        @media (max-width: 600px) { flex-direction: column;}
		.pic{z-index: 3; background-size: cover; margin: 0px; position: relative;
            
            @media (min-width: 600px) { width: 50%; border-radius: 0 15px 15px 0; }
            @media (max-width: 600px) { height: 100px; border-radius: 15px 15px 0 0; }
            
            .circles{position: absolute;left: -7px; margin: 0 auto;width: 12px;height: 100%;background: url(../assets/ticket_circle.png) repeat-y;  
                @media (min-width: 600px) {  }
                @media (max-width: 600px) { display: none; }
            }
        }
		
		.details{ z-index: 2; background: #f4f4f6; border-radius: 15px 0 0 15px; padding: 20px 25px;
            @media (min-width: 600px) { width: 50%; }
            @media (max-width: 600px) { }
			.date{display: flex; align-items: center; gap:5px;}
			.day{font-size: 56px;display: inline-block; line-height: 1; }
			span b{color: gray;letter-spacing: 0.8px;}
			
			.name{font-size: 20px;; color:rgba(0, 0, 0, 0.19);}
			.title{font-size: 23px; margin-bottom: 15px; text-align: right}
		}
		
		.fa-clock{margin-left: 8px}
		.fa-map-marker-alt{margin-left: 8px}
	}
	.btn{width: 150px;margin: 0 auto}
    
    
}
</style>